@if (sections().length > 0) {
  <p-tabs [(value)]="activeIndex" [scrollable]="true">
    <p-tablist>
      @for (section of sections(); track section.id; let i = $index) {
        <p-tab [value]="i">{{ section.title }}</p-tab>
      }
    </p-tablist>
    <p-tabpanels>
      @for (section of sections(); track section.id; let i = $index) {
        <p-tabpanel [value]="i">
          @if (section.questions.length > 0) {
            <app-question-list
              [questions]="section.questions"
              [showQuestionNumbers]="showQuestionNumbers()"
              [isReadOnly]="true"
              [previewMode]="true" />
          } @else {
            <p class="section-empty">This section has no questions.</p>
          }
        </p-tabpanel>
      }
    </p-tabpanels>
  </p-tabs>
} @else {
  <app-question-list
    [questions]="questions()"
    [showQuestionNumbers]="showQuestionNumbers()"
    [isReadOnly]="true"
    [previewMode]="true" />
}
